module.exports = __webpack_public_path__ + "static/DAWN1-8a99b615ab3c5fdd802d53f8393175fa.png";